define('ACS.PDPImei.Main', [
	'jQuery',
	'Utils',
	'underscore'
], function ACSPDPImeiMain(
	jQuery,
	Utils,
	_
) {
	'use strict';

	return {
		mountToApp: function mountToApp(container) {
			var cart = container.getComponent('Cart');
			var pdp = container.getComponent('PDP');
			var quantity;
			var imeiOption;
			var optionIds;
			var optionQyantity;
			var itemInfo;
			var simActivationRequired;

			if (cart && pdp) {
				cart.on('beforeAddLine', function (data) {
					itemInfo = pdp.getItemInfo();
					simActivationRequired = itemInfo && itemInfo.item && itemInfo.item.custitem_sim_activation_carrier;

					if (!_.isEmpty(simActivationRequired)) {
						quantity = data.line.quantity;
						imeiOption = _.find(data.line.options, { cartOptionId: 'custcol_imei_list' });
						optionIds = imeiOption.value && imeiOption.value.internalid;
						optionQyantity = optionIds && optionIds.length ? optionIds.split(',').length : 0;

						if (!optionQyantity) {
							return jQuery.Deferred().reject({
								'responseJSON': {
									'errorCode': 'ERR_EXT_CANCELED_OPERATION',
									'errorDetails': Utils.translate('Invalid IMEI or ICCID length. Please try again')
								},
								'responseText': JSON.stringify({
									'errorMessage': Utils.translate('Invalid IMEI or ICCID length. Please try again')
								})
							});
						}

						if (optionQyantity != quantity) {
							return jQuery.Deferred().reject({
								'responseJSON': {
									'errorCode': 'ERR_EXT_CANCELED_OPERATION',
									'errorDetails': Utils.translate('The quantity of the item and the number if registred IMEI should match')
								},
								'responseText': JSON.stringify({
									'errorMessage': Utils.translate('The quantity of the item and the number if registred IMEI should match')
								})
							});
						}
					}
				});
			}
		}
	};
});
